import React, { useState } from 'react';
import AdminSidebar from './components/AdminSidebar';
import Header from '../teacher_screen/components/Header';
import {
    Bus,
    Plus,
    Filter,
    MoreHorizontal,
    Search,
    MapPin,
    Users,
    Clock,
    ShieldCheck,
    AlertTriangle,
    Navigation,
    Phone
} from 'lucide-react';

export default function Transport() {
    const fleet = [
        { id: 'BUS-01', route: 'North-South Corridor', driver: 'Robert Brown', contact: '+1 234 567 801', capacity: 42, occupancy: 38, status: 'On Route' },
        { id: 'BUS-05', route: 'East Sector Express', driver: 'Wilson Davis', contact: '+1 234 567 805', capacity: 42, occupancy: 40, status: 'On Route' },
        { id: 'BUS-12', route: 'Urban Loop', driver: 'Sarah Smith', contact: '+1 234 567 812', capacity: 52, occupancy: 45, status: 'Maintenance' },
        { id: 'BUS-08', route: 'Hillside Shuttles', driver: 'Chris Miller', contact: '+1 234 567 808', capacity: 32, occupancy: 28, status: 'On Route' },
    ];

    return (
        <div className="flex h-screen bg-[#F8FAFC] overflow-hidden font-sans">
            <AdminSidebar />

            <main className="flex-1 overflow-y-auto px-8">
                <Header
                    title="Transport Logistics"
                    subtitle="Coordinate school fleet operations, route mapping and student safety"
                >
                    <button className="flex items-center gap-2 px-5 py-2.5 bg-blue-500 text-white rounded-xl text-[14px] font-bold shadow-lg shadow-blue-100 hover:bg-blue-600 transition-all uppercase tracking-tight">
                        <Plus size={18} />
                        Add Vehicle
                    </button>
                </Header>

                <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mb-10 overflow-hidden">
                    <div className="bg-white p-6 rounded-[24px] border border-gray-100 shadow-sm">
                        <p className="text-[11px] font-black text-gray-400 uppercase tracking-widest mb-1">Active Fleet</p>
                        <h4 className="text-[28px] font-black text-[#111827]">14 Units</h4>
                    </div>
                    <div className="bg-white p-6 rounded-[24px] border border-gray-100 shadow-sm">
                        <p className="text-[11px] font-black text-gray-400 uppercase tracking-widest mb-1">Daily Travelers</p>
                        <h4 className="text-[28px] font-black text-blue-500">582 Students</h4>
                    </div>
                    <div className="bg-white p-6 rounded-[24px] border border-gray-100 shadow-sm">
                        <p className="text-[11px] font-black text-gray-400 uppercase tracking-widest mb-1">Fuel Efficiency</p>
                        <h4 className="text-[28px] font-black text-emerald-500">92.4%</h4>
                    </div>
                    <div className="bg-white p-6 rounded-[24px] border border-gray-100 shadow-sm">
                        <p className="text-[11px] font-black text-gray-400 uppercase tracking-widest mb-1">Pending Repairs</p>
                        <h4 className="text-[28px] font-black text-rose-500">02</h4>
                    </div>
                </div>

                <div className="bg-white rounded-[32px] border border-gray-100 shadow-sm overflow-hidden flex flex-col mb-10 min-h-[500px]">
                    <div className="p-8 border-b border-gray-50 flex items-center justify-between bg-[#F8FAFC]/50">
                        <h3 className="text-[20px] font-black text-[#111827]">Operational Status Matrix</h3>
                        <div className="flex items-center gap-4">
                            <div className="relative group">
                                <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                                <input
                                    type="text"
                                    placeholder="Route or Driver..."
                                    className="pl-9 pr-4 py-2 bg-white border border-gray-100 rounded-xl text-[13px] font-bold text-gray-700 w-48 focus:outline-none focus:ring-2 focus:ring-blue-100"
                                />
                            </div>
                            <button className="p-2 text-gray-400 hover:text-gray-900 border border-gray-100 rounded-lg bg-white"><Filter size={18} /></button>
                        </div>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="w-full text-left">
                            <thead className="bg-[#F8FAFC]">
                                <tr>
                                    <th className="px-8 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase">Asset ID</th>
                                    <th className="px-6 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase">Route Designation</th>
                                    <th className="px-6 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase text-center">Load Factor</th>
                                    <th className="px-6 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase">Captain Info</th>
                                    <th className="px-8 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase text-center">Status</th>
                                    <th className="px-8 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase text-right">Ops</th>
                                </tr>
                            </thead>
                            <tbody>
                                {fleet.map((bus, i) => (
                                    <tr key={i} className="border-b border-gray-50 last:border-0 hover:bg-slate-50 transition-all group">
                                        <td className="px-8 py-5">
                                            <div className="flex items-center gap-3">
                                                <div className="w-10 h-10 bg-slate-100 rounded-xl flex items-center justify-center text-gray-400 group-hover:bg-[#111827] group-hover:text-white transition-all shadow-sm">
                                                    <Bus size={18} />
                                                </div>
                                                <span className="text-[14px] font-black text-blue-500 font-mono tracking-tighter">{bus.id}</span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-5">
                                            <div className="flex items-center gap-2.5 text-[15px] font-black text-[#111827] uppercase tracking-tight">
                                                <Navigation size={14} className="text-blue-500" />
                                                {bus.route}
                                            </div>
                                        </td>
                                        <td className="px-6 py-5 text-center">
                                            <div className="flex flex-col gap-1 items-center">
                                                <span className="text-[13px] font-black text-gray-700">{bus.occupancy} / {bus.capacity}</span>
                                                <div className="w-20 h-1 bg-slate-100 rounded-full overflow-hidden">
                                                    <div
                                                        style={{ width: `${(bus.occupancy / bus.capacity) * 100}%` }}
                                                        className={`h-full rounded-full ${bus.occupancy / bus.capacity > 0.9 ? 'bg-rose-500' : 'bg-emerald-500'}`}
                                                    ></div>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="px-6 py-5">
                                            <p className="text-[14px] font-black text-gray-700 leading-tight">{bus.driver}</p>
                                            <div className="flex items-center gap-1.5 text-[11px] font-bold text-gray-400 mt-0.5">
                                                <Phone size={10} /> {bus.contact}
                                            </div>
                                        </td>
                                        <td className="px-8 py-5 text-center">
                                            <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg text-[10px] font-black uppercase tracking-widest ${bus.status === 'On Route' ? 'text-emerald-500 bg-emerald-50' : 'text-amber-500 bg-amber-50'
                                                }`}>
                                                {bus.status === 'On Route' ? <ShieldCheck size={12} /> : <AlertTriangle size={12} />}
                                                {bus.status}
                                            </div>
                                        </td>
                                        <td className="px-8 py-5 text-right">
                                            <button className="px-4 py-1.5 bg-slate-50 text-gray-400 rounded-lg text-[11px] font-black hover:bg-blue-50 hover:text-blue-600 transition-all uppercase tracking-widest">
                                                Monitor
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </main>
        </div>
    );
}
